import { createSelector } from 'reselect';
import { getI18nConsts } from 'utils/i18n';
import { formatGeolocation } from 'utils';
import { selectCustomGeolocation } from 'flux/selectors/user.selectors'; // TODO: remove definitively tests #SDEU-35
import { selectLanguage } from 'flux/selectors/ui.selectors';
import {
  selectPropertyExtras,
  selectPropertyPinchableViewer,
} from 'flux/selectors/property.selectors';

export const selectApplication = (state) => state.application;
export const selectApplicationLoadingGeolocation = (state) => state.application.loadingGeolocation;
/** Pinch-to-zoom is enabled by the property extra `pinchable_viewer` (super admin) or by `?pinchableViewer=true`. */
export const selectApplicationPinchableViewer = (state) =>
  selectPropertyPinchableViewer(state) || Boolean(state.application.pinchableViewer);
export const selectApplicationFullscreen = (state) => state.application.fullscreen;

export const selectCustomGeolocationRequired = (state) =>
  state.application.customGeolocationRequired;
export const selectDefaultGeolocation = createSelector(selectLanguage, (language) => {
  const I18nConsts = getI18nConsts(language);
  if (!I18nConsts) return null;
  return formatGeolocation(I18nConsts.geolocation, 'countryDefault');
});

export const isUserGeolocationMissing = (state) => {
  const selectPropertyLocationRequired = selectPropertyExtras(state).location_required;
  return selectPropertyLocationRequired && !selectCustomGeolocation(state);
};

export const selectGclid = (state) => state.application.gclid;
// export const selectCustomLabel = state => state.application.customLabel
export const selectEnableDataLayerEvents = (state) => state.application.enableDataLayerEvents;
